import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowIcon from '@assets/img/icons/arrow-down.svg?react';
import { getImage } from '@common/lib/images';
import {
  type WorkshopUpgradeItemInfoProps,
  type WorkshopUpgradeItemLoad,
} from '@common/types/components';
import { StringSmall, StringXSmall } from '@components/Typography/Typography';
import { Container } from '@components/ui/Container/container';
import { Picture } from '@components/ui/Picture/Picture';

import ContractBackground from '@/components/common/ContractBackground/ContractBackground';
import { selectProductOfDayByGoodsType } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import productionPng from '/img/icons/production_pool.png';
import productionWebp from '/img/icons/production_pool.webp';

const CompaireItem: FC<
  WorkshopUpgradeItemInfoProps | WorkshopUpgradeItemLoad
> = (props) => {
  const { t } = useTranslation();
  let icon, altText, nowText, nextText, titleText;
  const productOfDay = useAppSelector((state) =>
    selectProductOfDayByGoodsType(
      state,
      'goodsName' in props ? props.goodsName : '',
    ),
  );

  if ((props as WorkshopUpgradeItemLoad).kind === 'load') {
    icon = {
      img: productionPng,
      webp: productionWebp,
    };
    titleText = t('Cycle Load');
    altText = (props as WorkshopUpgradeItemLoad).kind;
    nowText = props.now;
    nextText = props.next;
  } else {
    icon = getImage({
      name: (props as WorkshopUpgradeItemInfoProps).goodsName,
      field: 'icons',
    });
    titleText = t('Production speed');
    altText = (props as WorkshopUpgradeItemInfoProps).goodsName;
    nowText = `${props.now} sec.`;
    nextText = `${props.next} sec.`;
  }

  return (
    <Container
      padding="4-8"
      variant="task"
      className="backdrop-blur-3xl w-full flex items-center justify-between overflow-hidden"
    >
      <div className="flex items-center gap-2">
        <div className="relative  w-8 h-8  shrink-0">
          {productOfDay && (
            <ContractBackground
              type={productOfDay.type === 'premium' ? 'purple' : 'green'}
            />
          )}
          <Picture
            className="block"
            img={icon?.img}
            webp={icon?.webp}
            alt={altText}
          />
        </div>
        <StringXSmall
          weight="regular"
          className="!text-white/40 max-w-[6.5rem]"
        >
          {titleText}
        </StringXSmall>
      </div>
      <div className="flex items-center gap-2">
        <StringSmall weight="bold">{nowText}</StringSmall>
        <ArrowIcon className="w-4 h-4 shrink-0 -rotate-90 text-white/40" />
        <StringSmall weight="bold" className="!text-accent">
          {nextText}
        </StringSmall>
      </div>
    </Container>
  );
};

export { CompaireItem };
